import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AccountDto, LicenceDto } from 'src/app/dtos/dtos';
import { AccountService } from 'src/app/services/account.service';
import { LicenceService } from 'src/app/services/licence.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'je-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit, AfterViewInit {
  isEdit: boolean;
  perma: string;
  account: AccountDto = new AccountDto();
  licences: LicenceDto[];
  dataSource: MatTableDataSource<LicenceDto>;

  displayedLicenceColumns: string[] = [
    // 'id',
    'typeId',
    'period',
    'permaId',
    'description',
    'decision',
    'paid',
    'actions'];
  show: boolean = false;


  constructor(
    private accountService: AccountService,
    private licenceService: LicenceService,
    private not: NotificationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isEdit = this.router.url.indexOf('new') == -1;
  }

  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
    if (this.dataSource != null) {
      this.dataSource.sort = this.sort;
    }
    this.show = true;
  }

  ngOnInit() {
    if (this.isEdit) {
      this.perma = this.route.snapshot.paramMap.get('perma');
      this.loadAccount();
      this.loadLicences();
    }
  }

  private loadAccount() {
    this.accountService.get(this.perma).subscribe(response => {
      this.account = response;
    });
  }

  private loadLicences() {
    this.accountService.getAllLicences(this.perma).subscribe(response => {
      this.licences = response;
      this.dataSource = new MatTableDataSource(this.licences)
    });
  }

  submit() {
    return this.isEdit ? this.update() : this.create();
  }

  create() {
    this.accountService.create(this.account).subscribe(resp => {
      console.log(resp);
      this.navigateToList();
    });
  }

  update() {
    this.accountService.update(this.perma, this.account).subscribe(resp => {
      console.log(resp);
      this.navigateToList();
    });
  }

  delete() {
    this.not.confirm('Delete', 'Are you sure, you want to delete?')
      .afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.accountService.delete(this.perma).subscribe(resp => {
            console.log(resp);
            this.navigateToList();
          });
        }
      });
  }

  copyToYear(licence: LicenceDto): void {
    firstValueFrom(this.licenceService.copyForYear(licence.permaId, 2023))
      .then(() => {
        console.log('Created!');
      this.loadLicences();
      });
  }

  private navigateToList() {
    this.router.navigate(['/accounts']);
  }
}
